module.exports = __webpack_public_path__ + "img/photo-12.461696c2.webp";